import 'flowbite';

// Core
import youtube from "./core/youtube";
import googleMaps from "./core/google-maps";
import classicSelect from "./core/default-select";
import formatPhone from "./core/format-phone";

// Games
import gamesCarousel from "./games/games-carousel";

// Comments
import login from "../comments/login";
import registerUser from '../comments/register-user';
import verifyToken from '../comments/verify-token';
import logout from '../comments/logout';
import moreComments from '../comments/more-comments';
import sendComment from '../comments/send-comment';

// Auth
import '../auth/auth-module';

// Order Gift Card
import './gift-card/gift-card-module';

// Order Party
import './party/party-module';

// Admin Booking
import './admin-booking/index';

// Init Booking
import initBooking from './booking/booking-init';
const modInitBooking = new initBooking();
modInitBooking.init();

// Booking
import './booking/booking-module';

// Room booking
import roomInit from './booking/room/room-init';
const modRoomBooking = new roomInit();
modRoomBooking.init();

// Contact
import './contact/contact-module';

// Newsletter
import './newsletter/newsletter-module';

// Youtube
const modYoutube = new youtube();
modYoutube.getVideo();

// Classic Select
classicSelect('.ui-design-select');

// Format Phone
formatPhone();

// Slider home
import { sliderTop } from './home/top-slider';
const modSlider = new sliderTop();
modSlider.slider('.bl-box-home-slider .swiper');

// Comment login
const modLogin = new login(
    'loginCommentModal',
    'openCommentLogin',
    'closeLoginModal',
    '#loginCommentForm',
    '#comment-login-email',
    '#comment-login-password',
    'alertCommentLogin',
    'btnLoginCommentForm',
    'openCommentForgotPassword',
    'forgotPasswordModal',
    'closeForgotPasswordModal'
);

modLogin.getTemplateModal();

// Register user
const modRegisterUser = new registerUser(
    'signupCommentModal',
    'openCommentSignup',
    'closeSignupModal',
    '#signupCommentForm',
    'alertSignupCommentForm',
    'btnSignupCommentForm',
);

modRegisterUser.getTemplateModal();

// Verify token
const modVerifyToken = new verifyToken('#box-activate-comments');
modVerifyToken.checkToken();

// Logout
const modLogout = new logout(
    'btn-comments-logout',
);

modLogout.logout();

// More comments
const modMoreComments = new moreComments(
    '.btn-more-comments'
);

modMoreComments.loadComments();

// Add comment
const modAddComment = new sendComment(
    '#send-comment',
    'alertAddCommentForm',
    'btn-send-comment',
    'comments-list'
);

modAddComment.validateForm();

// Google maps
const modGoogleMpas = new googleMaps();
modGoogleMpas.initMap();

// Games
const modGamesCarousel = new gamesCarousel();
modGamesCarousel.listGames('.wrap-slide-games');